export default __webpack_public_path__ + "static/media/Q4_2.11fc76e4.jpg";